module.exports = __webpack_public_path__ + "static/media/online_s.248044fd.svg";